export const openBeaconMessage = ({ slug, title, subject, text }) => {
  if (typeof window === 'undefined' || !window.Beacon) {
    return false
  }

  const articleUrl = `${window.location.origin}${slug}`

  window.Beacon('prefill', {
    subject,
    text:
      text ??
      `I was reading this support article and still need help:\n\n${title}\n${articleUrl}`
  })
  window.Beacon('open')
  window.Beacon('navigate', '/ask/message/')

  return true
}
